













import Vue from 'vue';

export default Vue.extend({
  name: 'JerseyButton',
  props: {
    view: String,
    action: Function,
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    onButtonClick() {
      if (this.view && !this.isDisabled) {
        this.$store.commit('set_currentPage', this.view);
      } else if (this.action && !this.isDisabled) {
        this.action();
      }
    },
  },
});
